module.exports = __webpack_public_path__ + "img/map-small.c918bef3.jpg";